
import { defineComponent, computed, PropType } from 'vue'

export enum CounterType {
  Info = 'info',
  Default = 'default',
  Neutral = 'neutral',
  Minimal = 'minimal',
  Success = 'success',
  Warn = 'warn',
  Danger = 'danger'
}

export enum CounterDisplay {
  Absolute = 'absolute',
  Inline = 'inline'
}

enum CounterPosition {
  TopRight = 'top-right',
  BottomRight = 'bottom-right',
  BottomLeft = 'bottom-left',
  TopLeft = 'top-left',
  Center = 'center'
}

const MAX_LABEL_LENGTH = 150
const MAX_TOOLTIP_LENGTH = 1000
const IGNORABLE_LABELS = ['{}', 'null', 'undefined', 'NaN']

export default defineComponent({
  name: 'Counter',
  props: {
    display: {
      type: String as PropType<CounterDisplay>,
      default: CounterDisplay.Absolute
    },
    position: {
      type: String as PropType<CounterPosition>,
      default: CounterPosition.TopRight
    },
    offset: {
      type: Number,
      default: 0
    },
    index: {
      type: Number,
      default: 0
    },
    value: {
      type: [String, Number, Boolean],
      default: undefined
    },
    label: {
      type: String
    },
    tooltip: {
      type: String
    },
    type: {
      type: String as PropType<CounterType>,
      default: CounterType.Default
    }
  },
  setup (props) {
    function parseLabel (value: string): string {
      if (props.type === CounterType.Danger) {
        const s = (value || '').toString()
        if (IGNORABLE_LABELS.includes(s)) return ''
        return s
      }

      return value || ''
    }

    return {
      parsedValue: computed(() => {
        if (typeof props.value === 'boolean') return props.value
        return (props.type !== CounterType.Info && props.type !== CounterType.Neutral) ? parseInt(props.value as string) : props.value === undefined ? true : props.value
      }),
      parsedLabel: computed(() => {
        return `${parseLabel(props.label || '').substring(0, MAX_LABEL_LENGTH)}${(props.label || '').length > MAX_LABEL_LENGTH ? '...' : ''}`
      }),
      parsedTooltip: computed(() => {
        return `${String(props.tooltip || '').substring(0, MAX_TOOLTIP_LENGTH)}${String(props.tooltip || '').length > MAX_TOOLTIP_LENGTH ? '...' : ''}`
      })
    }
  }
})
